export default __webpack_public_path__ + "assets/discovery.7496d08629b6f12736b27282de030166.png";